module.exports = __webpack_public_path__ + "static/media/pattern.ddb3c483.jpg";